<template>
    <div class="modal-backdrop preview-modal" @click.self="$emit('close')">
        <div class="modal-content">
            <h3>Email Preview</h3>
            
            <div class="preview-content">
                <div class="preview-header">
                    <div class="preview-field">
                        <label>From:</label>
                        <span>Action Network &lt;hello@actionnetwork.com.au&gt;</span>
                    </div>
                    <div class="preview-field">
                        <label>To:</label>
                        <span>{{ type === 'member' ? 'All Members' : 'Speaker' }}</span>
                    </div>
                    <div class="preview-field">
                        <label>Subject:</label>
                        <span>{{ processedSubject }}</span>
                    </div>
                </div>

                <div class="preview-body" v-html="processedBody"></div>
            </div>

            <div class="modal-actions">
                <button @click="$emit('close')" class="close-btn">
                    Close
                </button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'EmailPreviewModal',
    props: {
        show: Boolean,
        type: String,
        subject: String,
        parsedBody: String,
        event: {
            type: Object,
            default: null
        },
        format: {
            type: Object,
            default: null
        }
    },
    computed: {
        processedSubject() {
            return this.subject;
        },
        processedBody() {
            if (!this.parsedBody) return '';
            
            // Convert line breaks to <br> tags for non-HTML content
            // But only for text between HTML tags, not inside HTML tags
            return this.parsedBody.replace(/(?<!>)\n(?!<)/g, '<br>');
        }
    }
}
</script>

<style scoped>
.preview-modal {
    z-index: 1200; /* Higher than the notification modal */
}

.modal-content {
    max-width: 800px;
    width: 95%;
    background: white;
    padding: 2rem;
    border-radius: 8px;
    max-height: 90vh;
    overflow-y: auto;
    position: relative;
    z-index: 1001;
}

.preview-content {
    background: #f8f9fa;
    border: 1px solid #ddd;
    border-radius: 4px;
    margin: 1rem 0;
    overflow-y: auto;
    max-height: calc(90vh - 200px); /* Account for header and buttons */
}

.preview-header {
    padding: 1rem;
    border-bottom: 1px solid #ddd;
    background: #fff;
    position: sticky;
    top: 0;
    z-index: 1;
}

.preview-field {
    display: flex;
    margin-bottom: 0.5rem;
}

.preview-field label {
    width: 80px;
    font-weight: 500;
    color: #666;
}

.preview-body {
    padding: 1.5rem;
    line-height: 1.5;
    text-align: left;
}

.preview-body :deep(table) {
    margin: 1rem 0;
    width: 100%;
}

.preview-body :deep(th),
.preview-body :deep(td) {
    text-align: left;
}

.close-btn {
    background: #6c757d;
    color: white;
    border: none;
    padding: 8px 16px;
    border-radius: 4px;
    cursor: pointer;
}

.close-btn:hover {
    background: #5a6268;
}
</style> 